export default __webpack_public_path__ + "static/media/ground-floor1.ada37026.jpg";